import { ca } from '@cian/analytics';
import { getClientDeviceType } from '../../../../../../shared/utils';

export const trackAddressSuccess = (isNewOffer, userRegion, formId) => {
  const siteType = getClientDeviceType();

  ca('eventSite', {
    name: 'oldevent',
    category: isNewOffer ? 'New_ad' : 'Edit_ad',
    action: 'GEO',
    label: 'address_success',
    page: {
      pageType: 'AddForm',
      siteType,
      extra: {
        userRegion,
        form_id: formId,
      },
    },
  });
};

export const trackAddressError = (isNewOffer, errorCode, formId) => {
  const siteType = getClientDeviceType();

  ca('eventSite', {
    name: 'oldevent',
    category: isNewOffer ? 'New_ad' : 'Edit_ad',
    action: 'GEO',
    label: 'address_error',
    page: {
      pageType: 'AddForm',
      siteType,
      extra: {
        errorCode,
        form_id: formId,
      },
    },
  });
};
